const pt = {
    common: {
        history: "versão histórica"
    }
};
export default pt;



// WEBPACK FOOTER //
// ./src/i18n/langs/pt.js